// @codekit-prepend quiet "lib/_jquery_3-6-0.min.js"
// @codekit-prepend quiet "lib/_bootstrap_bundle_5-1-3.min.js"
// @codekit-prepend quiet "lib/_slick_1-8-0.js"
// @codekit-prepend quiet "lib/_magnific_popup_1-1.min.js"
// @codekit-prepend "vc/_global.js"
// @codekit-prepend "vc/_custom_slick.js"
// @codekit-prepend "vc/_hero_slider.js"



import './lib/_bootstrap_bundle_5-1-3.min';
import './lib/_magnific_popup_1-1.min';
import './lib/_slick_1-8-0';

import './vc/_custom_slick';
import './vc/_global';
import './vc/_hero_slider';
